module.exports = __webpack_public_path__ + "7c0cc510208d893424419cf033516244.svg";